(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    safeInit(initBuyButtonTabs, 'USP Tabs');
    initGalleryAfterLCP();
  });

  /* ===============================
   * Safe init wrapper
   * =============================== */
  function safeInit(fn, name) {
    try {
      fn();
    } catch (e) {
      console.error('[PDP]', name, 'failed:', e);
    }
  }

  /* ===============================
   * BUY BUTTON USP TABS
   * =============================== */
  function initBuyButtonTabs() {
    var containers = document.querySelectorAll('.buy-button_usp_container');
    if (!containers.length) return;

    containers.forEach(function (container) {
      var tabs = container.querySelectorAll('.buy-button_usp');
      var contents = container.querySelectorAll('.buy-button_usp__content-item');
      if (!tabs.length || !contents.length) return;

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (item) {
            item.classList.remove('active');
          });
          contents.forEach(function (item) {
            item.classList.remove('active');
          });

          tabs[index].classList.add('active');
          if (contents[index]) contents[index].classList.add('active');
        });
      });
    });
  }

  /* ===============================
   * LCP-AWARE GALLERY INIT
   * =============================== */
  function initGalleryAfterLCP() {
    var didInit = false;
    var init = function () {
      if (didInit) return;
      didInit = true;
      safeInit(initActiveMediaGallery, 'Media Gallery');
    };

    var idle = window.requestIdleCallback || function (callback) {
      return window.setTimeout(callback, 1);
    };

    idle(init);
    window.setTimeout(init, 500);

    if ('PerformanceObserver' in window) {
      try {
        var lcpObserver = new PerformanceObserver(function (entryList) {
          var entries = entryList.getEntries();
          if (!entries.length) return;

          lcpObserver.disconnect();
          init();
        });

        lcpObserver.observe({ type: 'largest-contentful-paint', buffered: true });
      } catch (e) {
        idle(init);
      }
    } else {
      idle(init);
    }
  }

  /* ===============================
   * Detect active gallery
   * =============================== */
  function initActiveMediaGallery() {
    var desktop = document.querySelector('.product__media-block');
    var mobile = document.querySelector('.product__media-block-mobile');

    initVisibleGallery(desktop);
    initVisibleGallery(mobile);

    window.addEventListener('resize', throttle(function () {
      initVisibleGallery(desktop);
      initVisibleGallery(mobile);
    }, 150));
  }

  function initVisibleGallery(gallery) {
    if (isVisible(gallery)) initThumbSlider(gallery);
  }

  function isVisible(el) {
    if (!el) return false;
    return !!(el.offsetWidth || el.offsetHeight);
  }

  /* ===============================
   * THUMB SLIDER (shared)
   * =============================== */
  function initThumbSlider(root) {
    var wrap = root.querySelector('[data-thumbs]');
    if (!wrap) return;
    if (wrap.dataset.sliderInitialized === 'true') return;
    wrap.dataset.sliderInitialized = 'true';

    var track = wrap.querySelector('.thumb-track');
    var thumbs = wrap.querySelectorAll('.thumb-item');
    if (!track || !thumbs.length) return;

    var prev = wrap.querySelector('.thumb-prev');
    var next = wrap.querySelector('.thumb-next');
    var counter = wrap.querySelector('.thumb-counter');
    var currentEl = counter ? counter.querySelector('[data-current]') : null;
    var totalEl = counter ? counter.querySelector('[data-total]') : null;
    var tagsContainer = root.querySelector('.product_tags_container');

    var state = {
      index: 0,
      total: thumbs.length
    };

    if (totalEl) totalEl.textContent = state.total;

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        activate(i);
      });
    });

    if (prev) {
      prev.addEventListener('click', function () {
        activate(state.index - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        activate(state.index + 1);
      });
    }

    activate(0);
    updateUI();
    window.addEventListener('resize', throttle(updateUI, 150));

    function activate(i) {
      state.index = clamp(i, 0, state.total - 1);

      if (tagsContainer) {
        tagsContainer.toggleAttribute('hidden', state.index !== 0);
      }

      thumbs.forEach(function (thumb, thumbIndex) {
        thumb.classList.toggle('is-active', thumbIndex === state.index);
      });

      scrollThumbIntoView(track, thumbs[state.index]);

      if (currentEl) {
        currentEl.textContent = state.index + 1;
      }

      syncMainMedia(root, thumbs[state.index]);
    }

    function updateUI() {
      var overflow = track.scrollWidth > track.clientWidth;

      if (prev) prev.hidden = !overflow;
      if (next) next.hidden = !overflow;
      if (counter) counter.hidden = !overflow;
    }
  }

  /* ===============================
   * MAIN IMAGE SYNC
   * =============================== */
  function syncMainMedia(root, thumb) {
    var targetId = thumb.dataset.targetMediaId;
    if (!targetId) return;

    var items = root.querySelectorAll('.product-media-main [data-media-id]');
    if (!items.length) return;

    items.forEach(function (item) {
      var active = item.dataset.mediaId === targetId;
      item.classList.toggle('is-active', active);
      item.toggleAttribute('hidden', !active);
    });
  }

  /* ===============================
   * Horizontal-only scroll (NO Y jump)
   * =============================== */
  function scrollThumbIntoView(track, thumb) {
    var trackRect = track.getBoundingClientRect();
    var thumbRect = thumb.getBoundingClientRect();

    var offset =
      thumbRect.left -
      trackRect.left -
      (trackRect.width / 2) +
      (thumbRect.width / 2);

    track.scrollBy({
      left: offset,
      behavior: 'smooth'
    });
  }

  /* ===============================
   * Utils
   * =============================== */
  function clamp(v, min, max) {
    return Math.min(Math.max(v, min), max);
  }

  function throttle(fn, delay) {
    var last = 0;
    return function () {
      var now = Date.now();
      if (now - last >= delay) {
        last = now;
        fn();
      }
    };
  }
})();
